import React, { useEffect, useRef, useState } from "react";
import AnsweringPageFooter from "../../SharedComponents/AnswerIngPageFooter";
import FinishingModal from "../../SharedComponents/FinishingModal";
import TestItemImage from "./TestItemImage";
import { Counter } from "./Counter";
import "animate.css";
import { ExitFullscreen } from "../../../../Helpers/FullscreenHelper";
import { useNavigate } from "react-router-dom";

export function QuestionSlider({
  isB2b,
  questions,
  duration,
  openCam,
  finish,
  dismissFinish,
  Update,
  UpdateDurationAndPhoto,
  isFinished,
  HandleFinishButton,
}) {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  let percentage = (window.questionNo / questions.length) * 100 + "%";

  const [current, setCurret] = useState();
  const [maxQuestionNumber, setMaxQuestionNumber] = useState(0);

  const [finishModalShow, setFinishModalShow] = useState(false);
  const [isMediaRunning, setIsMediaRunning] = useState(false);
  const [stopCounter, setStopCounter] = useState(false);

  const imageRef = useRef();

  let AnswerinFooterNextButtonProps = {
    func: null,
    text: null,
    isDisabled: null,
  };

  function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  let NextQuestion = async () => {
    if (window.questionNo + 1 > questions.length) {
      setFinishModalShow(true);
      return;
    }
    //exit animation here
    await imageRef.current.ExitAnimation("next"); //goingTo
    renderQuestion(window.questionNo + 1);
  };
  let PrevQuestion = async () => {
    if (window.questionNo - 1 === 0) {
    } else if (window.questionNo <= maxQuestionNumber && window.questionNo > maxQuestionNumber - 1) {
      //exit animation here
      await imageRef.current.ExitAnimation("previous"); //goingTo
      renderQuestion(window.questionNo - 1, true);
    }
  };
  let SetEmptyQuestion = async () => {
    await SetAnswer(window.questionNo, 0, window.questionNo, false, 0);
  };

  const HandleEntryAnimation = (goToPrev) => {
    let textEntryAnimation = "temp";
    let answersEntryAnimation = "temp";

    if (goToPrev) {
      // if type is switching
      textEntryAnimation = "animate__backInLeft";
      answersEntryAnimation = "temp";
    } else {
      textEntryAnimation = "animate__backInRight";
      answersEntryAnimation = "temp";
    }

    if (window.questionNo === 0) {
      textEntryAnimation = "animate__fadeInDown";
      answersEntryAnimation = "animate__fadeInUp";
    }

    return { textEntryAnimation, answersEntryAnimation };
  };

  let Finish = () => {
    if (duration) setStopCounter(true);
    finish(questions);
    setFinishModalShow(false);
  };

  let DismisFinish = () => {
    dismissFinish(questions);
    setFinishModalShow(false);
  };

  let SetMediaClick = (order, mediaClickCount) => {
    questions.map((q) => {
      if (q.order === order) {
        q.mediaClickCount = mediaClickCount;
      }
    });
  };

  let SetUnAnsweredAnswerTime = (order, timer) => {
    questions.map((q) => {
      if (q.order === order) {
        if (q.timer) q.timer = q.timer + timer;
        else q.timer = timer;
      }
    });
  };

  let SetAnswer = async (order, option, n, isPolar, timer) => {
    questions.map((q) => {
      if (q.order === order) {
        q.answer = option;
        if (q.timer) q.timer = q.timer + timer;
        else q.timer = timer;
      }
    });
    isB2b && Update(questions);
    await NextQuestion();
    window.lastAnswerNo = n;
  };

  let renderQuestion = (n, goToPrev) => {
    if (n === 1 && !goToPrev) {
      //uygulama onceden baslami mi kontrol ediliyor, baslamis ise kalinan sira bulunuyor
      let startedBefore = questions.find((x) => {
        return x.answer !== undefined;
      });

      let last = questions.find((x) => {
        return x.answer === undefined;
      });

      if (last) n = last.order;
      else if (!last && startedBefore) {
        n = questions.length;
      }
    }
    if (maxQuestionNumber < n) setMaxQuestionNumber(n);
    const image = questions.find((x) => x.order === n);

    const entryAnimations = HandleEntryAnimation(goToPrev);

    window.questionNo = n;
    setCurret(
      <TestItemImage
        ref={imageRef}
        key={n}
        q={image}
        n={n}
        SetAnswer={SetAnswer}
        SetMediaClick={SetMediaClick}
        _isMediaRunning={isMediaRunning}
        _setIsMediaRunning={setIsMediaRunning}
        _startTime={new Date()}
        SetUnAnsweredAnswerTime={SetUnAnsweredAnswerTime}
        isLastQuestion={window.questionNo >= questions.length}
        goToPrev={goToPrev}
        textEntryAnimation={entryAnimations.textEntryAnimation}
        answersEntryAnimation={entryAnimations.answersEntryAnimation}
      />
    );
  };

  let HandleNextButtonFunctionAndText = () => {
    if (isFinished && (!Boolean(window.lastAnswerNo) || window.lastAnswerNo < window.questionNo)) {
      AnswerinFooterNextButtonProps = {
        func: () => {
          HandleFinishButton();
          navigate("/userDash");
          ExitFullscreen();
        },
        text: "Uygulamayı Bitir",
      };
    } else {
      AnswerinFooterNextButtonProps = {
        func: SetEmptyQuestion,
        text: "Boş Bırak",
      };
    }
  };

  HandleNextButtonFunctionAndText();

  return (
    <>
      <FinishingModal show={finishModalShow} Finish={Finish} DismisFinish={DismisFinish} />

      {duration && (
        <Counter
          duration={duration}
          Update={UpdateDurationAndPhoto}
          Finish={Finish}
          isB2b={isB2b}
          openCam={openCam}
          stopCounter={stopCounter}
        />
      )}
      <h4 className="test-question-no-at-heder">
        {window.questionNo} / {questions.length}
      </h4>
      <div className="test-question-progression-container" style={{ position: "fixed" }}>
        <div className="test-question-progression-bar" style={{ width: percentage, position: "fixed" }}></div>
      </div>
      <div className="animate__animated  animate__fadeInDown h-100">
        {!current && questions && renderQuestion(1)}
        {current}
      </div>
      <div style={{ display: isMediaRunning ? "none" : null }}>
        <AnsweringPageFooter
          prevButtonFunction={PrevQuestion}
          prevButtonText="Önceki"
          nextButtonText={AnswerinFooterNextButtonProps.text}
          nextButtonFunction={AnswerinFooterNextButtonProps.func}
          isNextDisabled={false}
          isPrevDisabled={
            !(window.questionNo <= maxQuestionNumber && window.questionNo > maxQuestionNumber - 1) ||
            window.questionNo === 1
          }
          hideSaveAndQuit={isFinished}
        />
      </div>
    </>
  );
}
